var e = require('wonka');

var r = require('@urql/core');

var t = require('@urql/core/internal');

function _extends() {
    return (_extends =
        Object.assign ||
        function (e) {
            for (var r = 1; r < arguments.length; r++) {
                var t = arguments[r];
                for (var n in t) {
                    if (Object.prototype.hasOwnProperty.call(t, n)) {
                        e[n] = t[n];
                    }
                }
            }
            return e;
        }).apply(this, arguments);
}

var n = 'undefined' != typeof window ? window.crypto || window.msCrypto : void 0;

var s = n && (n.subtle || n.webkitSubtle);

var o = !(!n || !window.msCrypto);

var i;

if ('undefined' == typeof window) {
    try {
        i = new Function('require', 'return require("crypto")')(require);
    } catch (e) {}
}

function hash(e) {
    try {
        if ('undefined' == typeof window ? !i || !i.createHash : !s) {
            if ('production' !== process.env.NODE_ENV) {
                console.warn(
                    '[@urql/exchange-persisted-fetch]: The ' +
                        ('undefined' == typeof window ? 'Node Crypto' : 'window.crypto.subtle') +
                        ' API is not available.\nThis is an unexpected error. Please report it by filing a GitHub Issue.'
                );
            }
            return Promise.resolve('');
        }
        if ('undefined' == typeof window) {
            return Promise.resolve('' + i.createHash('sha256').update(e).digest('hex'));
        }
        var r;
        if ('undefined' != typeof TextEncoder) {
            r = new TextEncoder().encode(e);
        } else {
            r = new Uint8Array(e.length);
            for (var t = 0, n = e.length; t < n; t++) {
                r[t] = e.charCodeAt(t);
            }
        }
        return Promise.resolve(
            (function sha256Browser(e) {
                var r = s.digest(
                    {
                        name: 'SHA-256',
                    },
                    e
                );
                return new Promise(function (e, t) {
                    if (o) {
                        r.oncomplete = function onComplete(r) {
                            e(new Uint8Array(r.target.result));
                        };
                        r.onerror = function onError(e) {
                            t(e);
                        };
                    } else {
                        Promise.resolve(r)
                            .then(function (r) {
                                e(new Uint8Array(r));
                            })
                            .catch(function (e) {
                                t(e);
                            });
                    }
                });
            })(r)
        ).then(function (e) {
            var r = '';
            for (var t = 0, n = e.length; t < n; t++) {
                var s = e[t].toString(16);
                r += '00'.slice(0, Math.max(0, 2 - s.length)) + s;
            }
            return r;
        });
    } catch (e) {
        return Promise.reject(e);
    }
}

function makePersistedFetchSource(n, s, o, i) {
    var u = r.makeOperation(
        n.kind,
        n,
        _extends({}, n.context, {
            preferGetMethod: i || n.context.preferGetMethod,
        })
    );
    var a = t.makeFetchURL(
        u,
        s.query
            ? s
            : _extends({}, s, {
                  query: '',
              })
    );
    var c = t.makeFetchOptions(u, s);
    'production' !== process.env.NODE_ENV &&
        o({
            type: 'fetchRequest',
            message: !s.query
                ? 'A fetch request for a persisted query is being executed.'
                : 'A fetch request is being executed.',
            operation: u,
            data: {
                url: a,
                fetchOptions: c,
            },
            source: 'persistedFetchExchange',
        });
    return e.onPush(function (e) {
        var r = e.error && (isPersistedMiss(e.error) || isPersistedUnsupported(e.error));
        var t = !e.data ? e.error : void 0;
        'production' !== process.env.NODE_ENV &&
            o({
                type: r || t ? 'fetchError' : 'fetchSuccess',
                message: r
                    ? 'A Persisted Query request has failed. A non-persisted GraphQL request will follow.'
                    : 'A ' + (t ? 'failed' : 'successful') + ' fetch response has been returned.',
                operation: n,
                data: {
                    url: a,
                    fetchOptions: c,
                    value: r ? e.error : t || e,
                },
                source: 'persistedFetchExchange',
            });
    })(t.makeFetchSource(u, a, c));
}

function isPersistedMiss(e) {
    return e.graphQLErrors.some(function (e) {
        return 'PersistedQueryNotFound' === e.message;
    });
}

function isPersistedUnsupported(e) {
    return e.graphQLErrors.some(function (e) {
        return 'PersistedQueryNotSupported' === e.message;
    });
}

exports.persistedFetchExchange = function persistedFetchExchange(r) {
    return function (n) {
        var s = n.forward;
        var o = n.dispatchDebug;
        if (!r) {
            r = {};
        }
        var i = !!r.preferGetForPersistedQueries;
        var u = !!r.enforcePersistedQueries;
        var a = r.generateHash || hash;
        var c = !0;
        return function (r) {
            var n = e.share(r);
            var d = e.mergeMap(function (r) {
                var s = r.key;
                var d = e.filter(function (e) {
                    return 'teardown' === e.kind && e.key === s;
                })(n);
                var f = t.makeFetchBody(r);
                if (!c) {
                    return e.takeUntil(d)(makePersistedFetchSource(r, f, o, !1));
                }
                var h = f.query;
                return e.takeUntil(d)(
                    e.mergeMap(function (t) {
                        if (!u) {
                            if (t.error && isPersistedUnsupported(t.error)) {
                                f.query = h;
                                f.extensions = void 0;
                                c = !1;
                                return makePersistedFetchSource(r, f, o, !1);
                            } else if (t.error && isPersistedMiss(t.error)) {
                                f.query = h;
                                return makePersistedFetchSource(r, f, o, !1);
                            }
                        }
                        return e.fromValue(t);
                    })(
                        e.mergeMap(function (e) {
                            if (e) {
                                f.query = void 0;
                                f.extensions = {
                                    persistedQuery: {
                                        version: 1,
                                        sha256Hash: e,
                                    },
                                };
                            }
                            return makePersistedFetchSource(r, f, o, !(!i || !e));
                        })(e.fromPromise(a(h, r.query)))
                    )
                );
            })(
                e.filter(function (e) {
                    return 'query' === e.kind;
                })(n)
            );
            var f = s(
                e.filter(function (e) {
                    return 'query' !== e.kind;
                })(n)
            );
            return e.merge([d, f]);
        };
    };
};
//# sourceMappingURL=urql-exchange-persisted-fetch.js.map
